/* gs-strive-daily-hydration — mobile center-triggered card reveal.

   Desktop uses :hover (CSS only). Mobile (touch) has no hover, so per
   Audrey's direction the title-lower + "learn more" reveal fires when
   each card crosses the VERTICAL CENTER of the viewport, and reverses
   when the card moves back out of the center band.

   Implementation: an IntersectionObserver with a thin center-band
   rootMargin (top: -50%, bottom: -50%) collapses the observation root
   to a 0-height strip across the viewport center. A card "intersects"
   that strip only while it is straddling the viewport's vertical mid-
   line, so the .is-centered class flips on/off naturally as the user
   scrolls past. We re-toggle on resize to handle orientation changes.

   Skipped:
     - viewport > 991px (desktop hover takes over)
     - prefers-reduced-motion: reduce
     - missing IntersectionObserver
*/
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 991px)';
  var REDUCED_QUERY = '(prefers-reduced-motion: reduce)';

  function arm(section) {
    if (section.dataset.gsDhArmed === '1') return;
    section.dataset.gsDhArmed = '1';

    var cards = section.querySelectorAll('.gs-strive-daily-hydration__card');
    if (!cards.length) return;

    var observer = null;

    function clearAll() {
      for (var i = 0; i < cards.length; i++) {
        cards[i].classList.remove('is-centered');
      }
    }

    function setup() {
      // Tear down any previous observer so we can rebuild for the
      // current viewport state without leaking listeners.
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      clearAll();

      var isMobile = window.matchMedia(MOBILE_QUERY).matches;
      var prefersReduced = window.matchMedia(REDUCED_QUERY).matches;
      if (!isMobile || prefersReduced || !('IntersectionObserver' in window)) {
        // Desktop / reduced-motion / no-IO: leave the cards in their
        // resting state. Desktop CSS :hover still works on its own.
        return;
      }

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-centered', entry.isIntersecting);
          });
        },
        {
          // Collapse the observation viewport to a 0-height band at the
          // vertical center. A card intersects this band only while its
          // own box overlaps the viewport's middle horizontal line.
          rootMargin: '-50% 0px -50% 0px',
          threshold: 0
        }
      );

      cards.forEach(function (el) { observer.observe(el); });
    }

    setup();

    // Re-evaluate on resize / orientation change so we don't strand the
    // observer in a state that no longer matches the viewport.
    var resizeRaf = 0;
    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(function () {
        resizeRaf = 0;
        setup();
      });
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.gs-strive-daily-hydration').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector
      ? e.target.querySelector('.gs-strive-daily-hydration')
      : null;
    if (root) arm(root);
  });
})();
